<template lang="pug">
  .section
    .columns.has-text-centered
      .column.is-12
        span
          h1.is-size-4 
          b Requisición {{requisicion.id_requisicion}}
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Datos de la Requisición&nbsp
            i.material-icons(slot='icon') more_vert
            .high(slot='content')
              DataRequisicion(:requisicion="requisicion")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Cotizaciones&nbsp
              span.tag.is-black
                b {{`Cotizaciones: ${cotizaciones.length}`}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content')
              Cotizaciones(:cotizaciones="cotizaciones")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Desglose de Items&nbsp
              span.tag.is-black
                b {{`Items: ${items.length}`}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content')
              TablaItemsExcel(:items="items" :requisicion="requisicion")
</template>

<script>
import DataRequisicion from './DataRequisicion.vue'
import TablaItemsExcel from './TablaItemsExcel.vue'
import Cotizaciones from './Cotizaciones.vue'
import InventarioServices from '../../services/inventario/inventario'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'

  export default {
    name: 'CardRequisicion',
    components: { DataRequisicion, TablaItemsExcel, Cotizaciones, BulmaAccordion, BulmaAccordionItem},
    props: {
      requisicion: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        items: [],
        cotizaciones: []
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerItems_Requisiones()
        this.obtenerCotizaciones()
      },
      obtenerItems_Requisiones() {
        InventarioServices.getItems_Requisiciones(this.requisicion.id)
          .then( data => {
            console.log(data)
            this.items = data
          })
          .catch( e => console.log(e))
      },
      obtenerCotizaciones () {
        InventarioServices.getCotizaciones(this.requisicion.id)
          .then( data => {
            console.log(data)
            this.cotizaciones = data
          })
          .catch( e => console.log(e))
      },
    },
    created () {
      this.iniciarComponente()
    }
  }
</script>

<style lang="css" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/CardRequisicion.vue